module.exports = __webpack_public_path__ + "static/media/team_3.cdfa5110.png";